import { render } from "./Ward.vue?vue&type=template&id=2a39f645&scoped=true"
import script from "./Ward.vue?vue&type=script&lang=js"
export * from "./Ward.vue?vue&type=script&lang=js"

import "./Ward.vue?vue&type=style&index=0&id=2a39f645&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a39f645"]])

export default __exports__